import { StatusChipColor } from "components/StatusChip";
import { assertNever } from "encamp-shared/src/utils/assertNever";
import {
  CersCupaConflictResolution,
  StaffCersCupaConflictResolutionsQuery,
} from "generated-graphql/graphql";

export type ResolutionRow =
  StaffCersCupaConflictResolutionsQuery["staffCersCupaConflictResolutions"]["items"][number];

/** Decision chip content — colors per the StatusChip semantic roles. */
export function decisionChip(resolution: CersCupaConflictResolution): {
  label: string;
  color: StatusChipColor;
} {
  switch (resolution) {
    case CersCupaConflictResolution.AcceptCers:
      return { label: "Accepted CERS", color: "info" };
    case CersCupaConflictResolution.KeepEncamp:
      return { label: "Kept Encamp", color: "success" };
    default:
      return assertNever(resolution);
  }
}

/** One-line description of what the decision did to the facility's LEPC. */
export function changeDisplay(row: ResolutionRow): string {
  switch (row.resolution) {
    case CersCupaConflictResolution.AcceptCers:
      return `${row.previousLepc.name} → ${row.cersLepc.name}`;
    case CersCupaConflictResolution.KeepEncamp:
      return `Kept ${row.previousLepc.name}`;
    default:
      return assertNever(row.resolution);
  }
}
